module.exports = __webpack_public_path__ + "static/media/case3.60aa98d3.jpg";